export const CARS_PRICE_KM = {
  'premium-minivan': 55,
  minivan: 32,
  premium: 63,
  comfort: 31,
  standart: 27,
};

// price_boarding - фіксована вартість посадки в машину
export const CARS_PRICE_BOARDING = {
  'premium-minivan': 500,
  minivan: 400,
  premium: 500,
  comfort: 350,
  standart: 300,
};

export const EXCHANGE_RATES = {
  CZK: 1,
  USD: 21,
  EUR: 24,
};
